import React, { useEffect, useState, useContext } from "react";
import { getBatchesRep } from "../api";
import { useNavigate, avigate, Link } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext"
import { deleteBatchConsolidado } from "../api"; // ajusta ruta si es distinta


const BatchListRep = ({ id_c }) => {
  const { t } = useContext(LanguageContext); // 👈 Usa el hook para traer traducciones
  const [data, setData] = useState(null);

  const [filterBatch, setFilterBatch] = useState("");
  const [filterMachine, setFilterMachine] = useState("");
  const [filterProduct, setFilterProduct] = useState("");

  const navigate = useNavigate(); // Hook para navegación




  useEffect(() => {
    const fetchData = async () => {
      const result = await getBatchesRep(id_c);
      console.log("📦 Batches recibidos:", result); // 👈 aquí
      setData(result);
    };
    fetchData();
  }, [id_c]);

  if (!data) return <p>{t('MList1')}</p>;



  // 👇 Aquí colocas este bloque justo después del `if (!data) return`
  const filterBatchClean = filterBatch.trim().toLowerCase();
  const filterMachineClean = filterMachine.trim().toLowerCase();
  const filterProductClean = filterProduct.trim().toLowerCase();

  const filteredData = data.batches.filter((batch) => {
    const batchIdStr = batch.id_batch?.toString().toLowerCase() ?? "";
    const codMaqStr = batch.cod_maq?.toLowerCase() ?? "";
    const idProdStr = batch.id_prod?.toString().toLowerCase() ?? "";



    return (
      batchIdStr.startsWith(filterBatchClean) &&
      codMaqStr.startsWith(filterMachineClean) &&
      idProdStr.startsWith(filterProductClean)
    );
  });


  console.log("🧪 Input actual:", filterProductClean);
  console.log("🔍 Resultados filtrados:");
  filteredData.forEach(batch => {
    console.log(batch.id_prod);
  });

  return (
    <div className="box1">
      <div className="box9">
        <button className="button7" onClick={() => navigate("/new_batch")}>
          {t('batchList11')}
        </button>

        {/* Inputs de búsqueda */}
        <div className="table5" >


          <input
            type="text"
            placeholder="🔎 Filtrar por lote"
            value={filterBatch}
            onChange={(e) => setFilterBatch(e.target.value)}
            style={{ width: "30%", float: "left" }}
          />
          <input
            type="text"
            placeholder="🔎 Filtrar por máquina"
            value={filterMachine}
            onChange={(e) => setFilterMachine(e.target.value)}
            style={{ width: "30%", float: "left" }}
          />
          <input
            type="text"
            placeholder="🔎 Filtrar por producto"
            value={filterProduct}
            onChange={(e) => setFilterProduct(e.target.value)}
            style={{ width: "30%", float: "left" }}
          />
        </div>


        <table className="table5">
          <thead>
            <tr>
              <th>{t("batchList12")}</th>
              <th>{t("batchList2")}</th>
              <th>{t("batchList3")}</th>
              <th>{t("batchList7")}</th>
              <th>{t("batchList8")}</th>
              <th>{t("batchList10")}</th>
              {/*} <th>{t("batchList13")}</th> */}
            </tr>
          </thead>
          <tbody>

            {filteredData.map((batch, index) => (
              <tr key={`${batch.id_batch}-${batch.id_prod}-${index}`}>


                <td>{batch.id_batch}</td>
                <td>{batch.cod_maq}</td>
                <td>{batch.id_prod}</td>
                <td>{new Date(batch.date_begin).toISOString().split("T")[0]}</td>
                <td>{batch.time_begin?.slice(0, 5)}</td>
                <td>{batch.time_end?.slice(0, 5)}</td>
             

              </tr>
            ))}
          </tbody>
        </table>

      </div>
    </div>
  );
};

export default BatchListRep;